<template>
    <Transition name="drop-down" v-bind:appear="true">
        <div
            v-if="list.length > 0"
            v-bind:class="['popover-cont', { 'no-bold-first': !boldFirstItem }]"
            v-bind:style="{ width: width + 'px', left: offsetLeftPosition + 'px' }"
        >
            <div class="popover-list">
                <div
                    v-for="item in list"
                    v-bind:key="item.value"
                    v-bind:class="[{ active: isActive(item), disable: item.disabled }, item.tabGA]"
                    class="popover-item"
                    v-on:click.stop="!item.disabled && onItemClick(item)"
                >
                    {{ item.title }}
                    <div class="growing-box" />
                    <TabCount v-if="isNumber(item.count)" v-bind:count="item.count" />
                </div>
            </div>
        </div>
    </Transition>
</template>

<script lang="ts" setup>
    import isNumber from 'lodash/isNumber';
    import { ref } from 'vue';
    import TabCount from '@/components/common/TabCount.vue';
    import type { IPopoverItem } from '@/interface/Tab';

    interface Props {
        width?: number;
        value: string | number;
        list: IPopoverItem[];
        parentRef: HTMLElement | null;
        boldFirstItem?: boolean;
    }

    const props = withDefaults(defineProps<Props>(), {
        width: 165,
        boldFirstItem: true,
    });

    const emit = defineEmits<(e: 'update', value: string | number) => void>();

    const maxRightPosition = ref(10);
    const offsetLeftPosition = ref(0);

    const isActive = (item: IPopoverItem) => props.value === item.value;

    const onItemClick = (item: IPopoverItem) => {
        emit('update', item.value);
    };

    const movePopoverPosition = () => {
        const { left: parentPosX } = props.parentRef?.getBoundingClientRect() ?? { left: 0 };
        const offset = window.innerWidth - (props.width + parentPosX + maxRightPosition.value);
        offsetLeftPosition.value = (offset < 0) ? offset : 0;
    };

    movePopoverPosition();
</script>

<style lang="scss">
    @import "@/scss/components/TabPopover";
</style>
